export const buildProvenance = { "commitHash": "6f1a9eb79d9674c57e94eeb2784a2c5b919fa06f", "branchName": "refs/heads/release/2024.1", "buildDate": "2024-03-29T04:37:50.358Z", "version": "2024.1.12210" };
